import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { onSelectedSubscriber } from '../../SpeedTestAndDisconnectionsWizardBlockThunk';
import Subscribers from '../../../../Shared/GeneralPages/Subscribers/Subscribers';

const SubscriberPage = (props) => {


    return (<Subscribers saleType={'internet'} onSelectSubscriber={handleOnSelectSubscriber} selectedSubscriber={props.productSubscriberNo} />);

    function handleOnSelectSubscriber(subscriber) {
        if (subscriber) {
            props.onSelectedSubscriber(subscriber);
        };
    };
};

const mapStateToProps = (state) => {
    return {
        productSubscriberNo: (state.selfcarePage?.isFetchData ? state.selfcarePage?.selectedSubscriber?.subscriberNumber : '')
    };
};

const mapDispatchToProps = {
    onSelectedSubscriber
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberPage);
